import React from 'react';
import { useState } from 'react';
import { useCallback } from 'react';
import './SubMenu_CM.css';
import Button from '../../Button';
import classNames from 'classnames';
import { ThemeSetup } from '../../../themes/ThemeSetup';
import RightClickMenuTooltip from '../../../constants/RightClickMenuTooltip';
import t from '../../../i18n/I18n';
import ToolTip from '../../AssetPropertyView';
type SubMenuProps = {
  items: array<any>,
  key: number,
  menuName: string,
  icon: ?string,
  iconOnHover: ?string,
  isComponent: ?boolean,
  Component: ?any
};

export const SubMenu_CM = (props: SubMenuProps) => {
  const {showCompomentAsLabel = false, isComponent, Component} = props;
  const [showOptions, setShowOptions] = useState(false);
  const onclick = useCallback((e: MouseEvent) => {
    const infos = e.currentTarget;
    setShowOptions(!showOptions);
    setTimeout(() => {
      getMorePos(infos);
    }, 200);
  });
  const toHide = useCallback(() => {
    setShowOptions(false);
  });
  const icon = showOptions
    ? props.iconOnHover
      ? ThemeSetup.getImageURL(props.iconOnHover)
      : props.icon || null
    : props.icon || null;
  // const label: string = props.menuName;
  const label: string = props.menuName ? props.menuName : '';
  const ToolTipLabel = RightClickMenuTooltip[t(label)?.toLowerCase()];
  return (
    <React.Fragment>
      <div
        name="sub-menu"
        className={showOptions ? 'selected' : ''}
        onMouseEnter={(event) => onclick(event)}
        onMouseLeave={toHide}>
        <div className={'flex-row align-center'}>
          {showCompomentAsLabel && isComponent ? Component : <Button icon={icon} type="PLAIN" text={props.menuName} title={ToolTipLabel}/>}
          <Button
            className={classNames('ExpandButton', { selected: showOptions })}
            icon={showOptions ? ThemeSetup.getImageURL('icons_expand.svg') : 'images/icons_expand.svg'}
          />
        </div>
        {showOptions ? (
          props.isComponent && !showCompomentAsLabel ? (
            <div className="component">{props.Component}</div>
          ) : (
            <div name="MorePopover_Portal" className="moreOption Submenu">
              {props.items.map((value) => value)}
            </div>
          )
        ) : null}
      </div>
    </React.Fragment>
  );
};

const getMorePos = (ref: HTMLElement) => {
  const element = ref.offsetParent?.querySelector('.moreOption');
  if (!element) return;
  const offsetWidth = element.offsetParent.offsetWidth;
  element.style.width = `${offsetWidth}px`;
  // const clickX = element.offsetParent.offsetWidth + element.offsetParent.offsetLeft;
  const clickY = element.offsetParent.offsetHeight + element.offsetParent.offsetTop;
  const screenW = window.innerWidth;
  const screenH = window.innerHeight;
  const rootW = element.offsetWidth;
  const rootH = element.offsetHeight;
  const ancestorBoundingRect = element.offsetParent.offsetParent?.getBoundingClientRect();
  const parentBoundingRect = element.offsetParent.getBoundingClientRect();
  let right = false;

  if(parentBoundingRect && !ancestorBoundingRect) {
    if(screenW > parentBoundingRect.x + (rootW*3) ){
      right = true;
    }else if((parentBoundingRect.x - (rootW*2)) > 0){
      right = false
    }else {
      if(screenW > parentBoundingRect.x + (rootW*2)){
        right = true;
      }else {
        right = false
      }
    }
  }

  if(parentBoundingRect && ancestorBoundingRect) {
    const ancestorBoundingTopRightX = ancestorBoundingRect.x + ancestorBoundingRect.width;
    const isParentOpenedInRight = Math.abs(ancestorBoundingTopRightX - parentBoundingRect.x) <= 10;
    if (isParentOpenedInRight) {
      if((screenW > (parentBoundingRect.x + (rootW * 2)))){
        right = true
      }else right = false
    } else {
      if((parentBoundingRect.x - rootW > 0)){
        right = false
      }else {
        right = true
      }
    }
  }
  const left = !right;
  const top = screenH > clickY + rootH;
  const bottom = !top;
  if (right) element.style.left = `100%`;
  if (left) element.style.left = `-100%`;
  if (top) element.style.top = `${ref.offsetTop - 6}px`;
  if (bottom) element.style.top = `${ref.offsetTop - element.offsetHeight + ref.offsetHeight + 6}px`;
  element.style.opacity = 'unset';
};
